import { Outlet } from 'react-router-dom';

// material-ui
import { Theme } from '@mui/material/styles';
import { Box } from '@mui/material';

// project imports

// assets

interface MainStyleProps {
    theme: Theme;
    open: boolean;
}

// ==============================|| MAIN LAYOUT ||============================== //

const MainLayout = () => {
    return (
        <Box sx={{ display: 'flex', flex: 1 }}>
            <Outlet />
        </Box>
    );
};

export default MainLayout;
